import React from 'react';
import CommentIcon from '@atlaskit/icon/glyph/comment';
import { useIntl } from '@atlassian/jira-intl';
import { NewField } from '../../../common/ui/new-field';
import messages from './messages';

export const ChatChannelField = () => {
	const { formatMessage } = useIntl();
	return (
		<NewField
			icon={<CommentIcon label="" />}
			title={formatMessage(messages.chatChannelTitle)}
			description={formatMessage(messages.chatChannelDescription)}
			link={{
				href: 'https://support.atlassian.com/jira-service-management-cloud/docs/create-a-chat-channel-from-an-incident/',
				text: formatMessage(messages.chatChannelLearnMoreLink),
				inProductHelpArticleId: '7sgNYVjMiXbWO2t7AMxsg8',
			}}
		/>
	);
};
